/**
 * <DropdownSelect />
 *
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes } from 'react';
import DropdownButton from "components/UI/DropdownButton";
import { MenuItem } from "react-bootstrap";
import './DropdownSelect.scss';
import find from 'lodash/find';

export function dropdownselect(props) {
  const {
    value,
    onChange,
    options,
    schema,
  } = props;

  const {
    noResultsText,
    selectOptions,
  } = options;

  const {
    name,
  } = schema;

  return (
    <DropdownSelect
      noResultsText={noResultsText}
      name={name}
      value={value}
      onChange={onChange}
      options={selectOptions}
    />
  );
}

class DropdownSelect extends React.Component {
  static propTypes = {

  }

  constructor(props) {
    super(props);

    this._getOptions = this._getOptions.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onClick(value) {
    return ()=>{
      this.props.onChange(value);
    }
  }

  render() {
    const {
      name,
      value,
      noResultsText,
      options,
      onChange,
      noCaret = true,
    } = this.props

    let title = __('Select', 'classdetail');
    if (typeof value !== 'undefined') {
      let item = find(options, { value });
      if (item && item.label) {
        title = item.label;
      }
    }

    return (
      <div className='dropdown-select form-input' >
        <DropdownButton bsStyle='link' title={title} className='dropdown-select-button' noCaret={noCaret} id='dropdown-select' >
          {this._getOptions()}
        </DropdownButton>
      </div>
    )
  }

	_getOptions() {
    const {
      options,
    } = this.props;

    return options.map((item, idx)=>{
      return (
        <MenuItem key={idx} onClick={this.onClick(item.value)} eventKey={idx}>{item.label}</MenuItem>
      );
		});
	}

}

export default DropdownSelect;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/DropdownSelect/index.js